




































































import { Component } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  BookMaxlength,
  MarkMaxlength,
  NdcMask,
  NdcMaxlength,
  SubMaxlength
} from '@/types'

export interface CallNumberEditItem {
  mark: string
  ndc: string
  book: string
  sub: string
}

export const defaultCallNumberEditItem = (): CallNumberEditItem => ({
  mark: '',
  ndc: '',
  book: '',
  sub: ''
})

export interface ModalCallNumberEditInterface {
  editItem: CallNumberEditItem
  onClickReflect: (item: CallNumberEditItem) => void
}

@Component({
  components: {
    ModalFooter
  }
})
export default class ModalCallNumberEdit extends ComponentVue {
  editItem: CallNumberEditItem = defaultCallNumberEditItem()

  reflectCallback?: (item: CallNumberEditItem) => void

  dialog: boolean = false

  get markMaxlength(): string {
    return MarkMaxlength
  }

  get ndcMask(): string {
    return NdcMask
  }

  get ndcMaxlength(): string {
    return NdcMaxlength
  }

  get bookMaxlength(): string {
    return BookMaxlength
  }

  get subMaxlength(): string {
    return SubMaxlength
  }

  // refによる直接呼出し前提の作りとなっている
  open(params: ModalCallNumberEditInterface): void {
    this.editItem = params.editItem
    this.reflectCallback = params.onClickReflect
    this.dialog = true
  }

  close(): void {
    this.editItem = defaultCallNumberEditItem()
    this.reflectCallback = undefined
    this.dialog = false
  }

  reflect(): void {
    if (this.reflectCallback) {
      this.reflectCallback(this.editItem)
    }
    this.close()
  }
}
